import { provideMaterialForSharedUi } from './provide-material-for-shared-ui';

/**
 * Custom icons added to the material icons' registry (placed in src/assets/img/icons)
 * The icons must be in SVG format and the key is always prefixed by "mm-".
 * All icons are sorted by alphabetical order!
 */
const CUSTOM_ICONS = {
  'mm-arrow-right': 'arrow-right.svg',
  'mm-ban': 'ban.svg',
  'mm-building': 'building.svg',
  'mm-caret': 'caret.svg',
  'mm-check': 'check.svg',
  'mm-check-green': 'check-green.svg',
  'mm-copy-icon': 'copy-icon.svg',
  'mm-cross': 'cross.svg',
  'mm-cross-black': 'cross-black.svg',
  'mm-cross-black-transparent': 'cross-black-transparent.svg',
  'mm-cross-grey': 'cross-grey.svg',
  'mm-danger': 'danger.svg',
  'mm-diamond': 'diamond.svg',
  'mm-doctor': 'doctor.svg',
  'mm-download': 'download.svg',
  'mm-drink': 'drink.svg',
  'mm-edit-icon': 'edit-icon.svg',
  'mm-envelop': 'envelop.svg',
  'mm-fluff': 'fluff.svg',
  'mm-glasses': 'glasses.svg',
  'mm-hexagon': 'hexagon.svg',
  'mm-home': 'home.svg',
  'mm-info-circle': 'info-circle.svg',
  'mm-info-circle-grey': 'info-circle-grey.svg',
  'mm-letter': 'letter.svg',
  'mm-light-bulb': 'light-bulb.svg',
  'mm-lock': 'lock.svg',
  'mm-logo-blue': 'logo-blue.svg',
  'mm-long-arrow-left-black': 'long-arrow-left-black.svg',
  'mm-long-arrow-right-black': 'long-arrow-right-black.svg',
  'mm-long-arrow-right-blue': 'long-arrow-right-blue.svg',
  'mm-long-arrow-right-dark-blue': 'long-arrow-right-dark-blue.svg',
  'mm-long-arrow-right-green': 'long-arrow-right-green.svg',
  'mm-long-arrow-right-yellow': 'long-arrow-right-yellow.svg',
  'mm-long-arrow-right-pink': 'long-arrow-right-pink.svg',
  'mm-long-arrow-right-red': 'long-arrow-right-red.svg',
  'mm-pencil': 'pencil.svg',
  'mm-phone': 'phone.svg',
  'mm-plane': 'plane.svg',
  'mm-search': 'search.svg',
  'mm-tooth': 'tooth.svg',
  'mm-shopping-cart': 'shopping-cart.svg',
  'mm-upload': 'upload.svg',
  'mm-shield': 'shield.svg',
  'mm-service-talents': 'service-talents.svg',
  'mm-service-employee': 'service-employee.svg',
  'mm-service-accounting': 'service-accounting.svg',
  'mm-service-insurance': 'service-insurance.svg',
  'mm-service-social': 'service-social.svg',
  'mm-service-worker': 'service-worker.svg',
  'mm-thumb': 'thumb.svg',
  'mm-trash': 'trash.svg',
  'mm-user': 'user.svg',
  'mm-compta-arrow-left': 'compta-arrow-left.svg',
  'mm-compta-arrow-right': 'compta-arrow-right.svg',
  'mm-compta-close': 'compta-close.svg',
  'mm-create': 'create.svg',
  'mm-add': 'add.svg',
  'mm-add-white': 'add-white.svg',
  'mm-suite-case': 'suite-case.svg',
  'mm-location': 'location.svg',
  'mm-user-yellow': 'user-yellow.svg',
  'mm-letter-yellow': 'letter-yellow.svg',
  'mm-eye-yellow': 'eye-yellow.svg',
  'mm-heart-yellow': 'heart-yellow.svg',
  'mm-trash-alt': 'trash-alt.svg',
};

export function provideShareMaterial() {
  return provideMaterialForSharedUi(CUSTOM_ICONS, './assets/img/icons/');
}
